import { Component } from '@angular/core';

@Component({
    selector: 'app-year-end-reflections-introduction',
    templateUrl: './year-end-reflections-introduction.component.html',
    styleUrls: ['./year-end-reflections-introduction.component.css'],
    standalone: false
})
export class YearEndReflectionsIntroductionComponent {

}
